var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33699 5.93279C6.72758 6.32325 6.72768 6.95642 6.33722 7.34701C5.21866 8.46593 4.457 9.8914 4.14853 11.4432C3.84006 12.995 3.99864 14.6034 4.60421 16.065C5.20979 17.5267 6.23517 18.7759 7.55071 19.6549C8.86625 20.5338 10.4129 21.0029 11.995 21.0029C13.5771 21.0029 15.1238 20.5338 16.4393 19.6549C17.7548 18.7759 18.7802 17.5267 19.3858 16.065C19.9914 14.6034 20.1499 12.995 19.8415 11.4432C19.533 9.8914 18.7713 8.46593 17.6528 7.34701C17.2623 6.95642 17.2624 6.32325 17.653 5.93279C18.0436 5.54233 18.6768 5.54244 19.0672 5.93302C20.4654 7.33168 21.4175 9.11351 21.8031 11.0532C22.1887 12.993 21.9905 15.0035 21.2335 16.8305C20.4765 18.6576 19.1948 20.2192 17.5504 21.3179C15.9059 22.4165 13.9727 23.0029 11.995 23.0029C10.0173 23.0029 8.08406 22.4165 6.43964 21.3179C4.79522 20.2192 3.51349 18.6576 2.75652 16.8305C1.99954 15.0035 1.80132 12.993 2.18691 11.0532C2.5725 9.11351 3.52458 7.33168 4.92278 5.93302C5.31324 5.54244 5.9464 5.54233 6.33699 5.93279Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C12.5523 1 13 1.44772 13 2V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V2C11 1.44772 11.4477 1 12 1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power-icon.b5e6501221a2a504714197333b34b611.svg";
export { ForwardRef as ReactComponent };